import { reportsModule } from "./modules/reports.js";

export function registerReportsModules(store) {
  store.registerModule(`reports`, reportsModule);

  return store;
}
